// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__2CI7k","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__12yZP"};